<template>
    <div class="customerDetail-module" v-show="render">
        <div v-if="isExpand" class="contact-box flex-y-center   flex-between">
            <div class="wechat flex-col flex-y-center " @click="toOpenWechat(isFriend, wxExternalUserid)">
                <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-17/wechat.png" class="icon-item chat-icon" alt="">
                <div class="contact-name">企微聊天</div>
            </div>
            <div class="make-call  flex-col  flex-y-center " @click="toContact(phone)">
                <img referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-17/phone.png" class="icon-item" alt="">
                <div class="contact-name">拨打电话</div>
            </div>
            <div class="icon-arrow  flex-1 flex-end flex-y-center" @click="toOpenContact(false)">
                <van-icon name="arrow" class="arrow-right" />
                <van-icon name="arrow" class="arrow-right" />
            </div>
        </div>
        <div v-else class="chat-box flex-y-center" @click="toOpenContact(true)">
            <van-icon name="arrow-left" class="arrow-left" />
            <van-icon name="arrow-left" class="arrow-left" />
        </div>
        <div class="head-box">
            <div class="head flex flex-row flex-between">
                <div class="head-info">
                    <div class="mb-10 flex flex-y-center">
                        <img v-if="customerDetails.avatar" class="photo" :src="customerDetails.avatar" alt="" />
                        <img v-else class="photo" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png" alt="" />
                        <div class="name ellipsis">{{ customerDetails.name }}</div>
                        <div class="cust-tag ellipsis" v-if="customerDetails.rtype">{{ customerDetails.rtype }}</div>
                        <div class="tag ellipsis">{{ customerDetails.type }}</div>
                    </div>
                    <div class="mb-40 FFFFFF flex flex-y-center font26">
                        <div class="phone">{{ customerDetails.resMobile }}</div>
                        <div class="store">{{ customerDetails.storeName }}</div>
                    </div>
                    <div class="FFFFFF font26 mb-10">
                        专属顾问：{{ customerDetails.consName }}
                    </div>
                    <div class="FFFFFF font26 mb-10">
                        最近到店时间：{{ customerDetails.latelyTime }}
                    </div>
                    <div class="FFFFFF font26 mb-10">
                        最近到店门店：{{ customerDetails.latelyStore }}
                    </div>
                </div>
                <div class="head-chart" @click="toArchives">
                    <div ref="headchart" id="headchart"></div>
                </div>
            </div>
        </div>
        <div class="tab-box">
            <van-tabs animated v-model="activeName">
                <van-tab title="顾客详情" name="detail">
                    <Detail :customerRecord="customerRecord" :customerConsume="customerConsume" :custId="customerDetails.id" />
                </van-tab>
                <van-tab title="顾客画像" name="picture">
                    <Picture :custId="custId" :mobile="phone" />
                </van-tab>
                <van-tab title="备忘录" name="remarks">
                    <Remarks :custId="custId" :name="customerDetails.name" :phone="phone" />
                </van-tab>
                <van-tab title="护理日志" name="diary">
                    <Diary :custId="custId" :phone="phone" />
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import Detail from "./components/detail.vue";
    import Picture from "./components/picture.vue";
    import Diary from "./components/diary.vue";
    import Remarks from "./components/remarks.vue";
    import { Toast } from 'vant'
    import { getCurExternalContact, getCurExternalChat, getContext, openEnterpriseChat, navigateToAddCustomer } from '@/utils/wxCodeAuth'
    import router from "@/router/router";
    export const TAB_NAME_SESSION_ID = 'customer-detail-tab-name'

    export default {
        name: "customerDetail",
        components: { Detail, Picture, Diary, Remarks },
        data() {
            return {
                render: false,
                custId: "", //顾客id
                phone: '',// 顾客手机号
                customerDetails: {}, //顾客详情
                rate: "", // 完成度
                customerRecord: {}, //客户档案
                customerConsume: {}, //客户消费
                nursingList: [], //护理日志
                total: 0, //总数
                activeName: "detail", //tab
                isFriend: 1, //是否好友
                wxExternalUserid: '',  //外部联系人ID
                isExpand: true,    //是否展开聊天对话
            };
        },
        beforeRouteEnter(to, from, next) {
            if (from.name === 'editDiary') {
                sessionStorage.setItem(TAB_NAME_SESSION_ID, 'diary')
            }
            else if (from.name === 'addRemarks') {
                sessionStorage.setItem(TAB_NAME_SESSION_ID, 'remarks')
            }
            next();
        },
      created() {
        console.log(this.$route.query);
      },
      mounted() {
            this.activeName = sessionStorage.getItem(TAB_NAME_SESSION_ID) ?? 'detail'
            sessionStorage.removeItem(TAB_NAME_SESSION_ID)
            this.init();
        },
        methods: {
          router() {
            return router
          },
            async init() {
                await this.judgeCustId()
                if (this.custId) {
                    this.getDetail().then(() => {
                        let rate = this.rate;
                        // 基于准备好的dom，初始化echarts实例
                        let myEcharts = this.$echarts.init(this.$refs.headchart);
                        window.onresize = myEcharts.resize;

                        let options = {
                            color: ["#8EE9E8", "#12BCC1"],
                            title: {
                                text:
                                    "{b|" +
                                    rate +
                                    "%}\n{c|" +
                                    "客户档案>" +
                                    "}\n{c|" +
                                    "完成度" +
                                    "}",
                                x: "center",
                                y: "center",
                                textStyle: {
                                    rich: {
                                        b: {
                                            fontSize: window.innerWidth * 40 / 750,
                                            color: "#ffffff",
                                            fontWeight: "bold",
                                            padding: [0, 0, 8, 0],
                                        },
                                        c: {
                                            fontSize: window.innerWidth * 22 / 750,
                                            color: "#ffffff",
                                            padding: [2, 0],
                                        },
                                    },
                                },
                            },
                            series: [
                                {
                                    name: "",
                                    type: "pie",
                                    radius: ["82%", "75%"],
                                    center: ["50%", "50%"],
                                    clockwise: true,
                                    label: {
                                        show: false,
                                        position: "center",
                                        fontSize: 12,
                                        fontWeight: "bold",
                                        color: "#ffffff",
                                        // formatter: "{b}\n{c}% \n{b} \n{b}",
                                        lineHeight: 3,
                                    },
                                    emphasis: {
                                        scale: false,
                                    },
                                    data: [
                                        {
                                            value: rate,
                                            name: "",
                                            label: {
                                                show: true,
                                            },
                                        },
                                        {
                                            value: 100 - rate,
                                            name: "",
                                        },
                                    ],
                                },
                            ],
                        };
                        myEcharts.setOption(options);
                    });
                    this.getCustomerRecord();
                    this.getCustomerConsume();
                }
            },
            // 判断是否有custid 无则获取
            async judgeCustId() {
                if (this.$route.query.custId && this.$route.query.phone) {
                    this.custId = this.$route.query.custId
                    this.phone = this.$route.query.phone
                    this.render = true
                } else {
                    await getContext().then(async (entry) => {
                        if (entry === 'group_chat_tools') {
                            await getCurExternalChat('').then(async (chatId) => {
                                this.$router.push({ name: "customerGroupList", query: { chatId } });
                            })
                        } else if (entry === 'single_chat_tools') {
                            this.render = true
                            const userId = await getCurExternalContact('')
                            await this.getCustomerId(userId)
                        }
                    })
                }
            },
            // userId换custid
            getCustomerId(userId) {
                return request({
                    url: `/contact/getCustomerId?wxExternalUserid=` + userId,
                    method: "get",
                }).then((res) => {
                    this.custId = res.data.custId;
                    this.phone = res.data.phone;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 顾客详情
            getDetail() {
                return request({
                    url: `/custinfo/details?custId=` + this.custId,
                    method: "get",
                }).then((res) => {
                    this.customerDetails = res.data;
                    this.rate = res.data.rate;
                    this.isFriend = res.data.isFriend;
                    this.wxExternalUserid = res.data.wxExternalUserid;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 客户档案
            getCustomerRecord() {
                return request({
                    url: `/custinfo/record?custId=` + this.custId,
                    method: "get",
                }).then((res) => {
                    this.customerRecord = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 客户消费
            getCustomerConsume() {
                return request({
                    url: `/custinfo/consume?custId=` + this.custId,
                    method: "get",
                }).then((res) => {
                    this.customerConsume = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            //跳转档案
            toArchives() {
                this.$router.push({ name: "customerArchives", query: { custId: this.custId } });
            },
            // 去打电话
            toContact(phone) {
                window.location.href = `tel:${phone}`;
            },
            //打开会话
            toOpenWechat(isFriend, wxExternalUserid) {
                if (isFriend == 1)   //是好友打开会话
                    openEnterpriseChat('', wxExternalUserid, '', '')
                else
                    //不是好友，打开添加客户页面
                    navigateToAddCustomer('')
            },
            //打开联系框
            toOpenContact(val) {
                this.isExpand = val;
            }
        },
    };
</script>
<style scoped lang="less">
    .mr-10 {
        margin-right: 10px;
    }

    .FFFFFF {
        color: #ffffff;
    }

    .black {
        color: #35434c;
    }

    .gray {
        color: #a0acb5;
    }

    /* ----- */
    .customerDetail-module {
        width: 750px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .head-box {
        width: 750px;
        background: linear-gradient(90deg, #1db2e4 0%, #4ae0d9 100%);
        color: #fff;
        position: relative;
        box-sizing: border-box;
        font-size: 34px;
        padding-bottom: 40px;
    }

    .head {
        padding-top: 48px;
    }

    .head-info {
        width: 520px;
        padding-left: 40px;
    }

    .head-info .photo {
        display: inline-block;
        width: 56px;
        height: 56px;
        background: #edf3ff;
        border-radius: 28px;
    }

    .head-info .name {
        display: inline-block;
        min-width: 122px;
        max-width: 252px;
        padding: 0 20px;
        text-align: center;
        font-size: 34px;
        font-weight: 700;
    }

    .head-info .tag {
        display: inline-block;
        height: 46px;
        padding: 0 20px;
        background: #249bb3;
        border-radius: 25px;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        line-height: 46px;
        text-align: center;
    }

    .head-info .cust-tag {
        display: inline-block;
        height: 46px;
        padding: 0 15px;
        background: #249bb3;
        border-radius: 25px;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        line-height: 46px;
        text-align: center;
        margin-right: 10px;
    }

    .head-info .phone {
        display: inline-block;
        margin-right: 26px;
    }

    .head-info .store {
        display: inline-block;
        width: 100%;
    }

    .head-chart {
        flex: 1;
    }

    #headchart {
        width: 250px;
        height: 250px;
    }

    /* ----- */
    .tab-box {
        padding: 50px 30px 50px 30px;
    }

    .contact-box {
        z-index: 999;
        position: fixed;
        right: 30px;
        top: 1172px;
        min-width: 352px;
        height: 130px;
        background: #333f48;
        border-radius: 71px;
        opacity: 0.8;
        align-items: center;

        .wechat {
            margin-left: 10%;
            min-width: 96px;
        }

        .make-call {
            margin-left: 8%;
            min-width: 96px;
        }

        .icon-item {
            width: 36px;
            height: 36px;
        }

        .contact-name {
            height: 33px;
            font-size: 24px;
            color: #ffffff;
            line-height: 33px;
            margin-top: 10px;
        }

        .icon-arrow {
            margin-left: 5%;
            width: 20px;
            height: 90px;
            margin-right: 5%;
        }

        :deep(.arrow-right.van-icon) {
            font-size: 26px !important;
            color: #ffffff !important;
            stroke: #fff;
            fill: transparent;
            stroke-width: 2px;
            animation: downMove 2s infinite;
            -webkit-animation: downMove 2s infinite;
            display: inline-block;
        }

        :deep(.arrow-right.van-icon:first-child) {
            width: 15px !important;
            animation-delay: 1s;
            -webkit-animation-delay: 1s;
        }

        :deep(.arrow-right.van-icon:last-child) {
            animation-delay: -0.8s;
            -webkit-animation-delay: -0.8s;
        }
    }

    .chat-box {
        width: 130px;
        height: 130px;
        background: #333f48;
        border-radius: 71px;
        opacity: 0.8;
        z-index: 999;
        position: fixed;
        left: 685px;
        top: 1172px;

        :deep(.arrow-left.van-icon) {
            font-size: 24px !important;
            color: #ffffff !important;
            stroke: #fff;
            fill: transparent;
            stroke-width: 2px;
            animation: downMove 2s infinite;
            -webkit-animation: downMove 2s infinite;
            display: inline-block;
        }

        :deep(.arrow-left.van-icon:last-child) {
            animation-delay: 0.8s;
            -webkit-animation-delay: 0.8s;
        }

        :deep(.arrow-left.van-icon:first-child) {
            width: 15px !important;
            margin-left: 10px !important;
            animation-delay: 1s;
            -webkit-animation-delay: 1s;
        }
    }

    /*  down */
    @keyframes downMove {
        0% {
            opacity: 0;
        }

        40% {
            opacity: 1;
        }

        80% {
            opacity: 0;
        }

        100% {
            opacity: 0;
        }
    }

    :deep(.van-tabs__line) {
        display: none;
    }

    :deep(.van-tab) {
        /* flex: none !important; */
        /* flex:0 0 25%!important; */
        width: 190px;
        padding: 0 !important;
        height: 70px !important;
        line-height: 70px !important;
        color: #a0acb5;
    }

    :deep(.van-tab.van-tab--active) {
        height: 70px !important;
        line-height: 70px;
        background: #2fd0d5 !important;
        border-radius: 35px !important;
        color: #fff !important;
        font-weight: 400 !important;
    }
</style>
